export default "__VITE_ASSET__BZauBfEr__"